import React from 'react';

import styled from 'styled-components';

import { CompanyListItemType } from './types';
import { MONTHS, SHOP_TIME_LABELS, SHOPS_PER_YEAR } from '../create/constants';

const Container = styled.div`
  display: flex;
  gap: 5px;
  font-family: var(--font-regular);
  color: var(--text-secondary);
  font-size: 12px;
  line-height: normal;
`;

const Text = styled.span`
  color: var(--text-primary);
  font-size: 14px;
`;

interface Props {
  item: CompanyListItemType;
}

const CompaniesTableShopsPerYear = ({ item }: Props) => {
  const { mystery_shop_setting } = item;
  const shopTime = mystery_shop_setting?.shop_time
    ? SHOP_TIME_LABELS[mystery_shop_setting?.shop_time].split(' ')[0]
    : '';
  const showQuarterlyMonths = mystery_shop_setting?.shops_per_year == SHOPS_PER_YEAR.QUARTERLY;
  const showSemiAnnuallyMonths = mystery_shop_setting?.shops_per_year == SHOPS_PER_YEAR.SEMI_ANNUALLY;
  const shopsMonths = mystery_shop_setting?.shop_months || [];

  return (
    <Container>
      <Text>{mystery_shop_setting?.shops_per_year ?? '-'}</Text>
      {Boolean(shopTime) && (
        <div style={{ display: 'flex' }}>
          <Text>(</Text>
          <div style={{ display: 'flex', gap: 5 }}>
            <Text>{shopTime}</Text>
            {showQuarterlyMonths && Boolean(shopsMonths.length) && (
              <Text>{`${shopsMonths.map((month) => MONTHS[month - 1]?.label).join(', ')}`}</Text>
            )}
            {showSemiAnnuallyMonths && Boolean(shopsMonths.length) && (
              <Text>{`${shopsMonths.map((month) => MONTHS[month - 1]?.label).join(' and ')}`}</Text>
            )}
          </div>
          <Text>)</Text>
        </div>
      )}
    </Container>
  );
};

export default CompaniesTableShopsPerYear;
